import Page from "../common/page";
import * as magazineListItem from '/src/ejs/component/component-magazine-img-list.ejs';
import {HtmlUtil} from "../utils/HtmlUtil";

export default class PageMagazineList extends Page {
    setPage() {
        let data = this.data.page.data.magazine;
        this.setHighlight(data.highlight);
        this.setList(data.list);
        this.setPaging(
            parseInt(data.current_page),
            parseInt(data.total_page),
            this.el.querySelector('.sec-2 .paging')
        );
    }

    setHighlight(data) {
        this.el.querySelectorAll('.sec-1 a').forEach((el) => el.setAttribute('href', data.link));
        this.el.querySelectorAll('.sec-1 img').forEach((el) => el.src =  data.img);
        this.el.querySelector('.sec-1 .txt-holder h3').innerHTML = data.title;
        this.el.querySelector('.sec-1 .txt-holder span').innerHTML = data.date;
    }

    setList(data) {
        this.listEl = this.el.querySelector('.sec-2 .magazine-list-holder ul');
        data.forEach((tmpData)=>{
            // console.log(tmpData);
            let element = HtmlUtil.getEjsElement(magazineListItem(), tmpData);
            this.listEl.appendChild(element);
        })
    }

}